import { connect } from 'react-redux';
import MiniIcon from 'app/commonComponents/miniIcon/miniIcon';

const mapStateToProps = ({ miniCart }) => ({
  totalItems: miniCart.totalItems,
});

export default connect(mapStateToProps)(MiniIcon);
